/**
 * MEMBERSHIP FORM
 * @todo: Ideally I'd like to nove this into a newly created "membership" directory
 */

import * as Forms from './forms';

(function( $ ) {
		let membershipFormId       = '#' + $( '.membership-app-form' ).attr( 'id' ),
		    checkUserBtnWasClicked = false;

		$( document ).ready( function() {
			'use strict';

			//only run on member application
			if ( $( 'body' ).hasClass( 'page-template-page-membership' ) ) {

				//needed for functions that clone sets of fields
				var cloneId = 0;

				let checkUserBtn   = $( '#btn-member-check-user' ),
				    checkUserField = $( '#member-email' );

				checkUserField.on( 'focus', function() {
					checkUserBtn.removeAttr( 'disabled' );
				} );

				checkUserEmail( checkUserBtn, checkUserField );

				$( '#select-member-app-dropdown' )
					.on( 'change', loadApplicationType );

				if ( $( '.membership-app-form' ).length ) {
					let addAddtContactBtn = $( '.btn-add-member-app-person' );

					$( '.membership-app-form' ).validator()
					                           .on( 'submit', revealSectionErrors );
					memberAppOtherConditionals();

					$( '#member-app-primary-contact-org-address input:checkbox' )
						.on( 'change', sameAsOrgAddress );
					$( '#member-app-same-as-primary-contact input:checkbox' )
						.on( 'change', sameAsPrimaryContact );
					$( '.btn-member-app-back' ).click( previousCollapsibleBtn );
					$( '.btn-member-app-next' ).click( nextCollapsibleAppBtn );

					//add new contact
					addAddtContactBtn.attr( 'disabled', 'disabled' )
					                 .addClass( 'disabled' );
					addAddtContactBtn.on( 'click', function() {
						cloneId++;
						addFormGroup( cloneId, 'additional-contacts-wrapper' );
						$( '.single-contact .conditional-required input' )
							.keyup( sometimesRequireAddtContactsFields );

						$( '.single-contact .conditional-required select' )
							.change( sometimesRequireAddtContactsFields );
					} );

					//remove dtcc number/authorized signature clones
					$( 'body' )
						.on( 'click', '#additional-contacts-wrapper .btn-remove-repeatable', function() {
							removeThisClone( $( this ) );
						} );

					$( '.single-contact .conditional-required input' )
						.keyup( sometimesRequireAddtContactsFields );

					$( '.single-contact .conditional-required select' )
						.change( sometimesRequireAddtContactsFields );
				}
			}
		} ); // doc ready

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * @param fieldList
		 */
		function disabled_conditional_fields_if_js_present( fieldList ) {
			//Will only disabled fields when not in "duplicate letter" mode
			if ( window.location.search.indexOf( 'duplicate=' ) < 1 ) {
				$.each( fieldList, function( index, value ) {
					let field        = $( '#' + value ),
					    condWrapperD = field.closest( '.conditional-section' );
					//only disable fields when not in "edit letter" mode
					if ( !field.hasClass( 'edit-mode-remove-disabled' ) && !condWrapperD.hasClass( 'enable-conditional-section' ) ) {
						field.attr( 'disabled', 'disabled' );
					}
				} );
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * @summary Add class for section errors
		 *
		 * Checks if the default was prevented due to the validator,
		 * and adds a class to the section containing errors.
		 */
		function revealSectionErrors( e ) {
			var form       = $( this ),
			    errorGroup = form.find( '.form-group.has-error' ),
			    errorStep  = errorGroup.closest( '.form-step' ),
			    formSteps  = form.find( '.form-step' );

			errorStep.addClass( 'section-has-error' );

			//check each step for errored groups
			formSteps.each( function() {
				var step = $( this ), groups = step.find( '.form-group' );

				if ( false === groups.hasClass( 'has-error' ) ) {
					step.removeClass( 'section-has-error' );
				}
			} );

		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * @summary Previous button in membership app
		 *
		 * Opens next section by triggering a click on expand/collapse btn
		 * Closes any other open sections
		 */
		function previousCollapsibleBtn() {
			var thisFormStep = $( this ).parents( '.form-step' ),
			    prevFormStep = thisFormStep.prev();

			scrollToFormTop( prevFormStep );
			//if the previous section isn't already open
			if ( prevFormStep.hasClass( 'closed' ) ) {

				//trigger click on previous section's toggle button
				prevFormStep.find( '.btn-section-toggle' ).trigger( 'click' );
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * @summary Next button in membership app
		 *
		 * Opens next section by triggering a click on expand/collapse btn
		 * Closes any other open sections
		 */
		function nextCollapsibleAppBtn() {
			var thisFormStep = $( this ).parents( '.form-step' ),
			    nextFormStep = thisFormStep.next();

			scrollToFormTop( nextFormStep );
			//if the next section isn't already open
			if ( nextFormStep.hasClass( 'closed' ) ) {
				//trigger click on next section's toggle button
				nextFormStep.find( '.btn-section-toggle' ).trigger( 'click' );
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * Scroll to step when prev/next buttons are clicked
		 *
		 * @param selector
		 */
		function scrollToFormTop( formStep ) {
			if ( formStep ) {
				$( 'html, body' ).animate( {
					                           scrollTop: ($( formStep )
						                                       .offset().top - 100
					                           )
				                           }, 500 );
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * Modular function to add repeatable field sets
		 * @param cloneId
		 * @param containerId
		 */
		function addFormGroup( cloneId, containerId ) {
			var wrapper                          = $( '#' + containerId ),
			    groups                           = wrapper.find( '.repeatable-form-group' ),
			    lastGroup = groups.last(), clone = lastGroup.clone()
			                                                .attr( 'id', containerId + '-' + cloneId )
			                                                .appendTo( wrapper );

			//if/else membership addt contacts
			if ( containerId === 'additional-contacts-wrapper' ) {
				//create clone and pass it to below func to update attrs
				updateRepeatableFieldAttrsContacts( wrapper, cloneId, clone );
			} else {
				//create clone and pass it to below func to update attrs
				updateRepeatableFieldAttrs( wrapper, cloneId, clone );
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * Remove clone via trigger (close button) in the repeatable form group
		 * @param trigger
		 */
		function removeThisClone( trigger ) {
			var cloneWrapper = trigger.parents( '.repeatable-form-group' );

			cloneWrapper.find( 'input[required="required"]' )
			            .removeAttr( 'required', 'required' );

			updateFormValidation( membershipFormId );

			cloneWrapper.remove();
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * @summary Update ids/for attrs for cloned field sets
		 * @param wrapper
		 * @param cloneId
		 * @param clone
		 */
		function updateRepeatableFieldAttrs( wrapper, cloneId, clone ) {
			/**
			 * Note: Assume there are always only 2 text fields that get repeated with matching labels
			 * 1. save original's form group field ids and label attrs to use for clones
			 * 2. Find the first and second form groups in each clone
			 * 3. Find the text inputs and labels in each clone's form group
			 * 4. Update the ids/for attrs for clone text fields and labels using the original's
			 * as a base and appended with the cloneId increment.
			 */
			var origRepeatable    = wrapper.find( '.repeatable-form-group:first-of-type' ),
			    origFirstFieldId  = origRepeatable.find( '.form-group:nth-child(1) input' )
			                                      .attr( 'id' ),
			    origSecondFieldId = origRepeatable.find( '.form-group:nth-child(2) input' )
			                                      .attr( 'id' ), //find clone form groups
			    origThirdFieldId  = origRepeatable.find( '.form-group:nth-child(3) input' )
			                                      .attr( 'id' ), //find clone form groups
			    firstCloneGroup   = clone.find( '.form-group:nth-child(1)' ),
			    secondCloneGroup  = clone.find( '.form-group:nth-child(2)' ), //find remove btns from form groups
			    thirdCloneGroup   = clone.find( '.form-group:nth-child(3)' ), //find remove btns from form groups
			    cloneRemoveBtn    = clone.find( '.btn-remove-repeatable .sr-only' ), //find fields and labels in the 2 form groups for clones
			    firstCloneField   = firstCloneGroup.children( 'input' ),
			    firstCloneLabel   = firstCloneGroup.children( 'label' ),
			    firstCloneName    = incrementIndexInFieldArray( firstCloneField ),
			    secondCloneField  = secondCloneGroup.children( 'input' ),
			    secondCloneLabel  = secondCloneGroup.children( 'label' ),
			    secondCloneName   = incrementIndexInFieldArray( secondCloneField ),
			    thirdCloneField   = thirdCloneGroup.children( 'input' ),
			    thirdCloneLabel   = thirdCloneGroup.children( 'label' ),
			    thirdCloneName    = incrementIndexInFieldArray( thirdCloneField );

			//apply id and for attr to first field
			firstCloneField.attr( 'id', origFirstFieldId + '-' + cloneId )
			               .attr( 'name', firstCloneName ).val( '' );
			firstCloneLabel.attr( 'for', origFirstFieldId + '-' + cloneId );

			//apply id and for attr to second field
			secondCloneField.attr( 'id', origSecondFieldId + '-' + cloneId )
			                .attr( 'name', secondCloneName ).val( '' );
			secondCloneLabel.attr( 'for', origSecondFieldId + '-' + cloneId );

			//apply id and for attr to third field
			thirdCloneField.attr( 'id', origThirdFieldId + '-' + cloneId )
			               .attr( 'name', thirdCloneName ).val( '' );
			thirdCloneLabel.attr( 'for', origThirdFieldId + '-' + cloneId );

			//add id to screen reader text in remove buttons
			cloneRemoveBtn.find( '.sr-append' ).remove(); //clear existing appends
			$( '<span class="sr-append"> ' + cloneId + '</span>' )
				.appendTo( cloneRemoveBtn );
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * Does the same thing as the function above, except with more fields
		 * due to the additional contacts on membership
		 *
		 * @param wrapper
		 * @param cloneId
		 * @param clone
		 */
		function updateRepeatableFieldAttrsContacts( wrapper, cloneId, clone ) {
			//@todo: Refactor into a moer efficient function at some point but rn this works
			var original      = wrapper.children( '.single-contact:nth-child(1)' ),
			    region        = original.find( '.form-group:nth-of-type(1) .form-control' ),
			    prefix        = original.find( '.form-group:nth-of-type(2) .form-control' ),
			    fname         = original.find( '.form-group:nth-of-type(3) .form-control' ),
			    lname         = original.find( '.form-group:nth-of-type(4) .form-control' ),
			    suffix        = original.find( '.form-group:nth-of-type(5) .form-control' ),
			    title         = original.find( '.form-group:nth-of-type(6) .form-control' ),
			    email         = original.find( '.form-group:nth-of-type(7) .form-control' ),
			    phone         = original.find( '.form-group:nth-of-type(8) .form-control' ),
			    fax           = original.find( '.form-group:nth-of-type(9) .form-control' ),
			    address       = original.find( '.form-group:nth-of-type(10) .form-control' ),
			    city          = original.find( '.form-group:nth-of-type(11) .form-control' ),
			    country       = original.find( '.form-group:nth-of-type(12) .form-control' ),
			    dataRegion    = country.attr( 'data-regionElement' ),
			    state         = original.find( '.form-group:nth-of-type(13) .form-control' ),
			    zip           = original.find( '.form-group:nth-of-type(14) .form-control' ),
			    keyArray      = [
				    region, prefix, fname, lname, suffix, title, email, phone,
				    fax, address, city, country, state, zip
			    ],
			    regionClone   = clone.find( '.form-group:nth-of-type(1) .form-control' ),
			    prefixClone   = clone.find( '.form-group:nth-of-type(2) .form-control' ),
			    fnameClone    = clone.find( '.form-group:nth-of-type(3) .form-control' ),
			    lnameClone    = clone.find( '.form-group:nth-of-type(4) .form-control' ),
			    suffixClone   = clone.find( '.form-group:nth-of-type(5) .form-control' ),
			    titleClone    = clone.find( '.form-group:nth-of-type(6) .form-control' ),
			    emailClone    = clone.find( '.form-group:nth-of-type(7) .form-control' ),
			    phoneClone    = clone.find( '.form-group:nth-of-type(8) .form-control' ),
			    faxClone      = clone.find( '.form-group:nth-of-type(9) .form-control' ),
			    addressClone  = clone.find( '.form-group:nth-of-type(10) .form-control' ),
			    cityClone     = clone.find( '.form-group:nth-of-type(11) .form-control' ),
			    countryClone  = clone.find( '.form-group:nth-of-type(12) .form-control' ),
			    stateClone    = clone.find( '.form-group:nth-of-type(13) .form-control' ),
			    zipClone      = clone.find( '.form-group:nth-of-type(14) .form-control' ),
			    keyCloneArray = [
				    regionClone, prefixClone, fnameClone, lnameClone,
				    suffixClone, titleClone, emailClone, phoneClone, faxClone,
				    addressClone, cityClone, countryClone, stateClone, zipClone
			    ];

			$.each( keyCloneArray, function( index, value ) {
				var field            = $( this ),
				    existingNameAttr = incrementIndexInFieldArray( field ),
				    originalId       = keyArray[ index ].attr( 'id' ),
				    originalRegion   = keyArray[ index ].attr( 'data-regionElement' ),
				    originalFor      = keyArray[ index ].siblings( '.control-label' )
				                                        .attr( 'for' );

				//empty clone fields
				field.val( '' );

				//add attributes/ids
				field.attr( 'id', originalId + '-' + cloneId );
				field.siblings( '.control-label' )
				     .attr( 'for', originalFor + '-' + cloneId );
				field.attr( 'name', existingNameAttr );

				//increment data region element
				if ( 'undefined' !== typeof field.attr( 'data-regionElement' ) ) {
					field.attr( 'data-regionElement', originalRegion + '-' + cloneId );
				}

				//"reset" states dropdown so country dropdown can populate from scratch
				if ( field.hasClass( 'addt-contact-state' ) ) {
					field.html( '<option>No States Available</option>' );
				}
			} );
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * Increment "name" attrs for fields
		 * @param elem
		 */
		function incrementIndexInFieldArray( elem ) {
			if ( $( elem ).length && $( elem ).attr( 'name' ) ) {
				return $( elem ).attr( 'name' )
				                .replace( /\[(\d+)\]/, function( match, number ) {
					                // `number` refers to the first group (denoted with ())
					                return '[' + (+number + 1
					                ) + ']';
				                } );
			}

			return '';
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * Re-validate form if fields have changed attrs
		 * @param $form
		 */
		function updateFormValidation( form ) {
			//submit validation on checkbox change
			$( form ).validator( 'update' );
		}

		/**
		 * Requires fields in addt contacts only if fields are filled in
		 * Based on class 'conditional-required' on .form-group
		 * In place only on the membership form
		 */
		function sometimesRequireAddtContactsFields() {
			var $fieldSelector = $( '.single-contact .conditional-required .form-control' ),
			    $emptyFields   = $fieldSelector.filter( function() {
				    return $.trim( this.value ) === '';
			    } ), addNewBtn = $( '.btn-add-member-app-person' );

			let memberForm = $( '.membership-app-form' );

			if ( $emptyFields.length < 9 ) {
				$emptyFields.attr( 'required', 'required' );
				addNewBtn.removeAttr( 'disabled', 'disabled' )
				         .removeClass( 'disabled' );
			} else {
				let stateField = $( '.conditional-state' );
				$emptyFields.removeAttr( 'required', 'required' );
				//remove required from state in case country was US
				stateField.children( '.form-control' )
				          .removeAttr( 'required', 'required' );
				stateField.children( '.help-block.with-errors' ).text( '' );
				addNewBtn.attr( 'disabled', 'disabled' ).addClass( 'disabled' );
				$emptyFields.closest( '.form-step' )
				            .removeClass( 'section-has-error' );
			}

			memberForm.validator( 'update' );
		}

		/**
		 * AJAX call to send Check User email address to user endpoint on membership form
		 * */
		function checkUserEmail( checkUserBtn, checkUserField ) {
			if ( checkUserBtn === null ) {
				return;
			}

			let formSubmitBtn = $( '.btn-member-app-submit' );

			checkUserField.on( 'blur', function( e ){
					if ( checkUserField.val() !== '' && checkUserBtnWasClicked === false ) {
						revealCheckUserMesssage( 'You must confirm your membership status before submitting the form by clicking the "Check Membership Status" button.', 'alert-danger', false );
				}
			});

			if ( !checkUserBtnWasClicked ) {
				formSubmitBtn.addClass( 'member-disabled' );
			} else {
				formSubmitBtn.removeClass( 'member-disabled' );
			}

			if ( formSubmitBtn.hasClass( 'member-disabled' ) && !formSubmitBtn.hasClass( '.disabled' ) ) {
				formSubmitBtn.attr( 'disabled', 'disabled' );
				//will this break anything?
				formSubmitBtn.addClass( 'disabled' );
			} else {
				formSubmitBtn.removeAttr( 'disabled', 'disabled' );
			}

			checkUserBtn.on( 'click', function( e ) {
				e.preventDefault();
				checkUserBtnWasClicked = true;

				let fieldFormGroup = checkUserField.parent( '.form-group' );

				if ( fieldFormGroup.hasClass( 'has-error' ) ) {
					//prevent user from clicking if format in field is wrong
					return;
				}

				$( '#check-membership-btn-text' ).addClass( 'hide' );
				$( '#check-membership-spinner' ).removeClass( 'hide' );

				passUserEmail( $( '#member-email' ).val() );
			} );
		}

		/**
		 * Function to pass user email to endpoint, checks if email is in iMIS
		 *
		 * @param email
		 */
		function passUserEmail( emailVal ) {
			let refreshBtn = $( '.btn-refresh-member-app-check-user' ),
			    submitBtn  = $( '.btn-member-app-submit' );

			$.ajax( {
				        type   : 'GET',
				        url    : wpApiSettings.root + 'isda/v1/check-user/?email=' + emailVal + '&userNonce=' + wpApiSettings.membershipCheckUser,
				        success: function( data ) {
					        refreshBtn.removeClass( 'hide' );
					        refreshBtn.on( 'click', refreshCheckUserState );

					        if ( data.result === true && data.is_member === true ) {

						        revealCheckUserMesssage( 'Thank you for your interest in ISDA Membership. <strong>' + data.member_company + '</strong> is already a member of ISDA.<br/> For more information, please contact Member Services.<br/> If you\'re trying to create an isda.org account, you can do so on the <a href="/my-account">sign up screen</a>.', 'alert-info' );
						        // TODO IMPLEMENT WP_NONCE ON PHP SIDE
						        //Disable form submission
						        submitBtn.addClass( 'member-disabled' );
					        } else {
						        revealCheckUserMesssage( 'Your company does not appear to be a member of ISDA. Please continue the application process below.', 'alert-warning' );

						        if ( $( '.form-step.step-1' )
							        .hasClass( 'closed' ) ) {
							        $( '.form-step.step-1 .btn-section-toggle' )
								        .trigger( 'click' );
						        }

						        //Enable form submission
						        submitBtn.removeClass( 'member-disabled' );
					        }

					        if ( submitBtn.hasClass( 'member-disabled' ) && !submitBtn.hasClass( '.disabled' ) ) {
						        submitBtn.attr( 'disabled', 'disabled' );
						        submitBtn.addClass( 'disabled' );
					        } else {
						        submitBtn.removeAttr( 'disabled', 'disabled' );
					        }
				        },
				        error  : function( data ) {
					        refreshBtn.removeClass( 'hide' );
					        refreshBtn.on( 'click', refreshCheckUserState );

					        revealCheckUserMesssage( 'Something has gone wrong - please re-check your email address and try again.', 'alert-danger' );
				        }
			        } );
		}

		/**
		 * Reveal message after user is checked
		 * @param text
		 * @param alertClass
		 */
		function revealCheckUserMesssage( text, alertClass, hideBtn = true ) {
			let messageWrap = $( '.help-block-with-errors-check-user' );

			if ( !messageWrap.hasClass( alertClass ) ) {
				messageWrap.removeClass( function( index, className ) {
					return (className.match( /(^|\s)alert-\S+/g ) || []
					).join( ' ' );
				} ).addClass( alertClass );
			}

			messageWrap.html( text ).removeClass( 'hide' );

			if ( hideBtn ) {
				$( '#btn-member-check-user' ).hide();
			}
		}

		/**
		 * Restart Check User State and re-show check member status button
		 */
		function refreshCheckUserState( e ) {
			e.preventDefault();
			checkUserBtnWasClicked = false;

			revealCheckUserMesssage( 'You must confirm your membership status before submitting the form by clicking the "Check Membership Status" button.', 'alert-danger', false );

			$( this ).addClass( 'hide' );
			$( '#btn-member-check-user' ).show();
			$( '#check-membership-btn-text' ).removeClass( 'hide' );
			$( '#check-membership-spinner' ).addClass( 'hide' );
		}

		/**
		 * Reloads membership application to match the type selected in dropdown
		 */
		function loadApplicationType() {
			var applicationType = '/' + $( '#select-member-app-dropdown' )
				    .val(), url = window.location.href,
			    regex           = /(application)\S+/,
			    updatedUrl      = url.replace( regex, 'application' );

			updatedUrl += applicationType;
			window.location.href = updatedUrl;
		}

		/**
		 * @summary Make text field required if "Other" is chosen
		 *
		 * Member App w/ radios that have "other" as an option w/ a text field
		 * toggles the required/disabled attrs so that the text field will
		 * validate if the related radio button is selected.
		 *
		 * Uses class "member-app-conditional-radio" on the "radio" div to
		 * determine if it contains a radio that is "other".
		 */
		function memberAppOtherConditionals() {
			//if "other" is selected, make following text field required
			$( 'input:radio' ).focus( function() {
				var thisRadio       = $( this ),
				    radioClass      = thisRadio.closest( '.radio' ),
				    otherFieldGroup = radioClass.parent().next(),
				    otherField      = otherFieldGroup.find( 'input:text' );

				if ( radioClass.hasClass( 'member-app-conditional-radio' ) ) {
					//remove disabled from text field
					otherFieldGroup.removeClass( 'hidden' );
					//add required from text field
					otherField.attr( 'required', 'required' );

				} else {
					//remove required from text field
					otherField.removeAttr( 'required', 'required' );
					otherField.val( '' );
					//disable text field
					otherFieldGroup.addClass( 'hidden' );
				}

				updateFormValidation( membershipFormId );
			} );
		}

		/**
		 * Same as org address checkbox on membership form
		 */
		function sameAsOrgAddress() {
			if ( $( this ).is( ':checked' ) ) {
				let phoneVal   = $( '#organization-phone' ).val(),
				    faxVal     = $( '#organization-fax' ).val(),
				    addressVal = $( '#organization-address' ).val(),
				    cityVal    = $( '#organization-city' ).val(),
				    countryVal = $( '#organization-country' ).val(),
				    zipVal     = $( '#organization-zip' ).val();

				$( '#primary-contact-phone' ).val( phoneVal )
				                             .focus();
				$( '#primary-contact-fax' ).val( faxVal ).focus();
				$( '#primary-contact-address' ).val( addressVal )
				                               .focus();
				$( '#primary-contact-city' ).val( cityVal )
				                            .focus();
				$( '#primary-contact-country' ).val( countryVal )
				                               .focus();
				$( '#primary-contact-zip' ).val( zipVal ).focus();

				setStateValue( 'primary' );
			}
		}

		/**
		 * Same as primary contact checkbox on membership form
		 */
		function sameAsPrimaryContact() {
			if ( $( this ).is( ':checked' ) ) {
				var prefixVal  = $( '#primary-contact-prefix' ).val(),
				    fnameVal   = $( '#primary-contact-fname' ).val(),
				    lnameVal   = $( '#primary-contact-lname' ).val(),
				    suffixVal  = $( '#primary-contact-suffix' ).val(),
				    titleVal   = $( '#primary-contact-title' ).val(),
				    emailVal   = $( '#primary-contact-email' ).val(),
				    phoneVal   = $( '#primary-contact-phone' ).val(),
				    faxVal     = $( '#primary-contact-fax' ).val(),
				    addressVal = $( '#primary-contact-address' ).val(),
				    cityVal    = $( '#primary-contact-city' ).val(),
				    countryVal = $( '#primary-contact-country' ).val(),
				    zipVal     = $( '#primary-contact-zip' ).val();

				$( '#legal-opinion-contact-prefix' ).val( prefixVal )
				                                    .focus();
				$( '#legal-opinion-contact-fname' ).val( fnameVal )
				                                   .focus();
				$( '#legal-opinion-contact-lname' ).val( lnameVal )
				                                   .focus();
				$( '#legal-opinion-contact-suffix' ).val( suffixVal )
				                                    .focus();
				$( '#legal-opinion-contact-title' ).val( titleVal )
				                                   .focus();
				$( '#legal-opinion-contact-email' ).val( emailVal )
				                                   .focus();
				$( '#legal-opinion-contact-phone' ).val( phoneVal )
				                                   .focus();
				$( '#legal-opinion-contact-fax' ).val( faxVal ).focus();
				$( '#legal-opinion-contact-address' ).val( addressVal )
				                                     .focus();
				$( '#legal-opinion-contact-city' ).val( cityVal ).focus();
				$( '#legal-opinion-contact-country' ).val( countryVal ).focus();
				$( '#legal-opinion-contact-zip' ).val( zipVal ).focus();

				setStateValue( 'legal' );
			}
		}

		function setStateValue( fieldType ) {
			//assumes we're pulling from org to primary contact
			let stateDropdownSrc    = $( '#organization-state' ),
			    stateDropdownTarget = $( '#primary-contact-state' );

			//pull from primary to legal contact
			if ( fieldType === 'legal' ) {
				stateDropdownSrc = $( '#primary-contact-state' ), stateDropdownTarget = $( '#legal-opinion-contact-state' );
			}

			//set html before value
			stateDropdownTarget.html( stateDropdownSrc.html() );
			stateDropdownTarget.val( stateDropdownSrc.val() );
		}
	}
)( jQuery );